import { api } from './api';

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => {
        return {
          url: 'doLogin',
          method: 'POST',
          body: credentials,
        };
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: 'doLogout',
        method: 'POST',
      }),
    }),
    check: builder.mutation({
      query: () => 'doCheck',
    }),
    requestPasswordReset: builder.mutation({
      query: (email) => ({
        url: 'requestPasswordReset',
        method: 'POST',
        body: { email },
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ token, newPassword }) => ({
        url: 'resetPassword',
        method: 'POST',
        body: { token, newPassword },
      }),
    }),
    updateMyLocale: builder.mutation({
      query: (locale) => ({
        url: 'updateMyLocale',
        method: 'POST',
        body: { locale },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useCheckMutation,
  useRequestPasswordResetMutation,
  useResetPasswordMutation,
  useUpdateMyLocaleMutation,
} = authApi;

export const {
  endpoints: {
    login,
    logout,
    check,
    requestPasswordReset,
    resetPassword,
    updateMyLocale,
  },
} = authApi;
